export default {
  title: 'Sugerencias de IA',
  subtitle: 'Sugerencias del agente de FoodAmigos para tus restaurantes.',
  empty: 'Nada que mostrar aquí.',
  tabs: {
    pending: 'Pendiente',
    history: 'Historial',
  },
  table: {
    id: 'ID',
    company: 'Restaurante',
    type: 'Tipo',
    summary: 'Sugerencia',
    created_at: 'Creado',
    status: 'Estado',
    actions: 'Acciones',
  },
  statuses: {
    pending: 'Pendiente',
    confirmed: 'Confirmado',
    applied: 'Aplicado',
    rejected: 'Rechazado',
    failed: 'Fallido',
    expired: 'Expirado',
  },
  types: {
    'smart_pricing.global_reduce': 'Descuento en todo el menú',
    'smart_pricing.category_reduce': 'Descuento por categoría',
    'competitor_listing.confirm': 'Confirmar listado en marketplace',
    'catalog.price_correct': 'Corrección de precio',
    'catalog.add_item': 'Añadir artículo faltante',
    'catalog.quality': 'Calidad de contenido',
    'catalog.reorder': 'Reordenar menú',
  },
  actions: {
    review: 'Revisar',
    confirm: 'Confirmar',
    reject: 'Rechazar',
    cancel: 'Cancelar',
    edit: 'Editar',
  },
  edit: {
    label: 'Describe el cambio que deseas (se genera una nueva revisión)',
    placeholder: 'Describe el cambio que deseas',
    placeholders: {
      'smart_pricing.global_reduce': 'p. ej. ponlo al 15 %, renómbralo «Summer -15%» o aplícalo solo a delivery',
      'smart_pricing.category_reduce': 'p. ej. establece el descuento de Bebidas al 10 % y elimina la recogida',
      'catalog.price_correct': 'p. ej. elimina la corrección de «Cola» o establece «Pizza» a €7.50',
      'catalog.add_item': 'p. ej. elimina el artículo «Water» o fija «Falafel Wrap» a €6.50',
      'catalog.quality': 'p. ej. elimina los artículos «Fries» y «Cola» de la lista',
      'catalog.reorder': 'p. ej. pon Bebidas al final y mueve el más vendido al inicio de Bowls',
      'competitor_listing.confirm': 'p. ej. reemplaza el enlace de Uber Eats por https://…, o añade Wolt: https://…',
    },
    submit: 'Generar revisión',
  },
  revisions: {
    label: 'Revisión',
    original: 'Original',
    revision_n: 'Revisión {{n}}',
  },
  detail: {
    title: 'Detalle de sugerencia',
    targets: 'Artículos afectados',
    evidence: 'Por qué el agente sugiere esto',
    no_targets: 'No se han proporcionado detalles del artículo.',
    composed_from: 'Compuesto de',
    items_suffix: 'artículos',
    nutrition: 'Nutrición',
    uncategorized: 'Sin categoría',
    decided_by: 'Decidido por',
    decision_note: 'Nota',
    category_existing: 'existente',
    category_new: 'nuevo',
    product: 'Producto',
    price_change: 'Cambio de precio',
    no_items: 'Sin artículos',
    fills_image: '+ imagen',
    fills_description: '+ descripción',
    fills_nutrition: '+ nutrición',
    fills_modifiers: '+ modificadores',
    competitor_links: 'Enlaces de la competencia',
    no_competitor_links: 'Aún no hay enlaces de la competencia resueltos.',
  },
  competitors: {
    lieferando: 'Lieferando',
    wolt: 'Wolt',
    deliveroo: 'Deliveroo',
    uber_eats: 'Uber Eats',
  },
  reject_modal: {
    title: 'Rechazar esta sugerencia',
    note_label: 'Motivo',
    note_placeholder: 'Explica brevemente por qué rechazas esta sugerencia',
  },
  toasts: {
    load_failed: 'Error al cargar las sugerencias',
    confirmed: 'Sugerencia confirmada',
    rejected: 'Sugerencia rechazada',
    action_failed: 'No se pudo completar la acción',
    revision_created: 'Nueva revisión generada',
    revision_failed: 'No se pudo generar una revisión con esa instrucción',
    choose_revision: 'Esta sugerencia tiene varias revisiones — ábrela y elige una para confirmar',
  },
};
